import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

import { isArray } from 'lodash';

import moment from 'moment';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Input, DateTime } from '~/components/Form';

import { t } from '~/helpers';
import api from '~/services/api';

import { FormWrapper } from './styles';

import * as S from './styles';

export default function MyForm({ data, reference, close, cancelarAcao }) {

  async function handleSubmit(param) {
    try {

      //data.fatu_datahora_validacao_gestor
      //validações pickerFatuDataFatura


      if (data.fatu_datahora_validacao_gestor === null) {
        toast.error('Data de validação do gestor inválida!');
        await cancelarAcao();
        return;
      }

      let dataAtual = moment().format("YYYY-MM-DD");

      let dtnDigData_pedido = moment(param.data_pedido, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD");

      let dtnDatahora_validacao_gestor = moment(data.fatu_datahora_validacao_gestor, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");

      let fatu_data = moment(param.data_pedido ,"DD/MM/YYYY").format("YYYY/MM/DD");


      let sparam = {
        ...param,
        data_pedido : fatu_data,        
      }



      const schema = Yup.object().shape({
        numero_pedido: Yup.string()          
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, 'Este campo deve ter no mínimo 1 caractere(s)')
          .max(20, 'Este campo deve ter no maximo 20 caractere(s)'),
        // data_pedido: Yup.string().required(
        //     t('s.geral.validacao.campoobrigatorio')
        //   ),
        data_pedido: Yup.date()
          .typeError('Data invalida')
          .nullable('Data invalida')
          .min(new Date(dtnDatahora_validacao_gestor), `Data invalida, deve ser maior que ${moment(data.fatu_datahora_validacao_gestor, "YYYY-MM-DD HH:mm:ss").format('DD/MM/YYYY')} `)
          .max(new Date(), `Data invalida, deve ser menor que ${moment(new Date(), 'YYYY-MM-DD HH:mm:ss', true).format('DD/MM/YYYY')} `)
          .required(t('s.geral.validacao.campoobrigatorio')
          ),


      });

      await schema.validate(sparam, {
        abortEarly: false,
      });

      if (moment(dtnDigData_pedido).isAfter(dataAtual)) {
        toast.error('Data de envio da nota fiscal maior que a data atual!');
        await cancelarAcao();
        return;
      }

      if (moment(dtnDatahora_validacao_gestor).isAfter(dtnDigData_pedido)) {
        toast.error('Data do pedido deve ser maior que a data validação gesto!');
        await cancelarAcao();
        return;
      }

      

      const objSend = {
        fatu_codigo: param.fatu_codigo,
        numero_pedido: param.numero_pedido,
        data_pedido: moment(param.data_pedido, 'DD/MM/YYYY HH:mm:ss', true).format('DD/MM/YYYY') , 
        fatu_datahora_validacao_gestor: moment(data.fatu_datahora_validacao_gestor, "YYYY-MM-DD HH:mm:ss").format('DD/MM/YYYY'),
        //data_pedido  : param.data_pedido,
      };

      await api.put('radadmdadosfaturamentounidata/incluinumerorpedidofatura', objSend);
      toast.success(t('s.geral.sucessoalteracao'));

      await close();
    } catch (err) {
      await cancelarAcao();

      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <>

      <S.Wrapper>

        <FormWrapper ref={reference} initialData={data} onSubmit={handleSubmit}>

          <Input
            name="fatu_codigo"
            label="Número da Pré-Fatura:"
            disabled
          />

          <Input
            name="orga_nome"
            label="Órgão:"
            disabled
          />

          <Input
            name="numero_pedido"
            label="Pedido:"
          />

          <DateTime
            //nullable
            name="data_pedido"
            label='Data do Pedido:'
            disablePast={false}
            disableFuture={true}
            invalidDateMessage={''}

            minDateMessage={''}
            //minDateMessage="Data inválida!"
            maxDateMessage=""
            minDate={ (data.fatu_datahora_validacao_gestor !== null)?data.fatu_datahora_validacao_gestor: new moment()}
            serialize={(value) =>
               value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
            }
          />


        </FormWrapper>
      </S.Wrapper>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
  cancelarAcao: PropTypes.func.isRequired,
};
